<template>
  <div class="development-path-swiper-wrapper">
    <swiper class="swiper" ref="swiper" :options="swiperOption">
      <swiper-slide v-for="(item, index) in developmentPath" :key="index">
        <div class="card">
          <div class="date">{{ formatUTC(item.FDate) }}</div>
          <div class="content">
            <!-- <p>{{ item.con }}</p> -->
            <div class="con" v-html="formatBody(item)"></div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev" slot="button-prev">
      <i class="iconfont icon-jiantou_liebiaoxiangzuo"></i>
    </div>
    <div class="swiper-button-next" slot="button-next">
      <i class="iconfont icon-jiantou_liebiaoxiangyou"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      developmentPath: []
    };
  },
  mounted() {
    this.$store.dispatch("getCourseData").then(res => {
      this.developmentPath = res.Data;
    });
  },
  methods: {
    formatUTC(datetime) {
      const date = new Date(datetime);
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate())
      );
    },
    formatBody(item) {
      let body;
      if (this.$i18n.locale === "zh") {
        body = item.Body;
      } else if (this.$i18n.locale === "en") {
        body = item.EnglishBody;
      } else if (this.$i18n.locale === "sp") {
        body = item.xibanyaBody;
      }
      return body;
    }
  }
};
</script>

<style lang="less" scoped>
.development-path-swiper-wrapper {
  position: relative;

  .swiper-container {
    width: 90%;
    padding: 40px 0;

    .swiper-wrapper {
      .swiper-slide {
        .card {
          width: 260px;
          height: 210px;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
          margin: 0 auto;

          .date {
            width: 100%;
            height: 75px;
            line-height: 75px;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: rgba(85, 85, 85, 1);
            border-bottom: 1px solid #dcdcdc;
          }

          .content {
            padding: 20px;

            .con {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              height: 105px;
              line-height: 20px;
              color: rgba(85, 85, 85, 1);
              -webkit-line-clamp: 5;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .con:hover {
              background: #fff;
              height: 150px;
              position: relative;
              z-index: 5;
              padding: 10px;
              margin-top: -10px;
              margin-left: -10px;
              border-radius: 8px;
              box-shadow: 0 8px 16px 0 rgba(7, 17, 27, 0.2); /*加阴影*/
              -webkit-line-clamp: inherit; /*去掉省略*/
              overflow-y: auto;
            }
          }
        }
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: rgba(0, 100, 178, 1);
    border-radius: 50%;
    outline: none;

    .iconfont {
      color: #fff;
      font-size: 22px;
    }
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    content: "";
  }
}
</style>
